import React, { useState, useEffect } from "react";
import {
  Input,
  Collapse,
  Button,
  Alert,
  Label,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Select from "react-select/lib/Select";
export default function ExternalUserLoginSignup({
  setLoginModalOpen,
  setLoginDetails,
  loginDetails,
  handleProceed,
  externalUserData,
  setExternaluserData,
  benchmarks,
  modalType,
  setModalType,
}) {
  const [tab, setTab] = useState(1);
  useEffect(() => {
    if (modalType == 1) {
      setTab(2);
    }
  }, []);

  const isSubmitDisabled=()=>{
    let flag = true
    if(tab===1){
      if(externalUserData.email && externalUserData.password && externalUserData.companyName){
         flag = false
      }
    }else{
      if(loginDetails.email && loginDetails.password){
        flag = false
      }
    }

    return flag
  }

  return (
    <div>
      <Modal isOpen={true}>
        <ModalHeader toggle={() => setLoginModalOpen(false)}>
         
         {tab===1 ?"Sign up":"Login"}
        </ModalHeader>
        <ModalBody>
          <div>
            {tab == 1 ? (
              <span>
                Register and submit.{" "}
                <a className="link-text" onClick={() => setTab(2)}>
                  Click here to login
                </a>{" "}
              </span>
            ) : (
              <span>
                Login with email and password.{" "}
                {
                  modalType != 1 &&   <a
                  onClick={() => {
                    setTab(1);
                    setModalType(2);
                  }}
                  className="link-text"
                >
                  Click here to register.
                </a>
                }
              {" "}
              </span>
            )}
          </div>
          {tab === 2 ? (
            <Row className="mt-3">
              <Col sm={6}>
                <Label>Email</Label>
                <Input
                  type="email"
                  value={loginDetails.email}
                  placeholder="Enter email"
                  onChange={(e) => {
                    setLoginDetails({
                      ...loginDetails,
                      email: e.target.value,
                    });
                  }}
                  autocomplete={false}
                />
              </Col>
              <Col sm={6}>
                <Label>Password </Label>
                <Input
                  type="password"
                  value={loginDetails.password}
                  placeholder="Enter password"
                  onChange={(e) => {
                    setLoginDetails({
                      ...loginDetails,
                      password: e.target.value,
                    });
                  }}
                  autocomplete={false}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col sm={12}>
                <div className="my-4">
                  <Row>
                    <Col>
                      <Label>Company name</Label>
                      <Input
                        value={externalUserData.companyName}
                        placeholder="Enter company name"
                        onChange={(e) => {
                          setExternaluserData({
                            ...externalUserData,
                            companyName: e.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col>
                      <Label>Email</Label>
                      <Input
                        type="email"
                        value={externalUserData.email}
                        placeholder="Enter email"
                        onChange={(e) => {
                          setExternaluserData({
                            ...externalUserData,
                            email: e.target.value,
                          });
                        }}
                        autocomplete={false}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col>
                      <Label>Password</Label>
                      <Input
                        type="password"
                        value={externalUserData.password}
                        placeholder="Enter password"
                        onChange={(e) => {
                          setExternaluserData({
                            ...externalUserData,
                            password: e.target.value,
                          });
                        }}
                        autocomplete={false}
                      />
                    </Col>
                    <Col>
                      {/* <Label>Industry</Label>
                      <Select
                        value={externalUserData.selectedBenchmarkId}
                        options={benchmarks}
                        placeholder="Select Industry"
                        onChange={(v) => {
                          if (v) {
                            setExternaluserData({
                              ...externalUserData,
                              selectedBenchmarkId: v.value,
                            });
                          } else {
                            setExternaluserData({
                              ...externalUserData,
                              selectedBenchmarkId: null,
                            });
                          }
                        }}
                      /> */}
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            disabled={isSubmitDisabled()}
            onClick={() => {
              if (modalType === 1) {
                handleProceed("login");
                setLoginModalOpen(false)
              } else {
                handleProceed("register");
                setLoginModalOpen(false)
              }
            }}
          >
            Submit
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
